import React, { createContext, useContext, useState } from "react";

const WizardContext = createContext(null);

export function WizardProvider({
  steps,
  initialValues = {},
  onSubmit,
  validationSchema,
  children,
  dropdowns,
  searchWizard,
  setSearchWizard,
  stepsConfig,
  setStepsConfig,
  ...props
}) {
  const [values, setValues] = useState(initialValues);
  const [current, setCurrent] = useState(0);

  const next = (step) => {
    if(step || step === 0)return setCurrent(step);
    if (validationSchema) {
      validationSchema.validate(values).then(() => {
        if (current + 1 < steps.length) setCurrent(current + 1);
        else onSubmit(values);
      });
    } else {
      if (current + 1 < steps.length) setCurrent(current + 1);
      else onSubmit(values);
    }
  };
  const back = (step) => setCurrent(step);
  const goTo = (i) => setCurrent(i);
  const setField = (name, v) => setValues((vals) => ({ ...vals, [name]: v }));
  const updateValues = (name, v) =>
    setValues((prev) => ({ ...prev, [name]: v }));

  return (
    <WizardContext.Provider
      value={{
        values,
        current,
        steps,
        next,
        back,
        goTo,
        setField,
        updateValues,
        dropdowns,
        searchWizard,
        setSearchWizard,
        stepsConfig,
        setStepsConfig,
        setValues,
        ...props
      }}
    >
      {children}
    </WizardContext.Provider>
  );
}

export function useWizard() {
  const ctx = useContext(WizardContext);
  if (!ctx) throw new Error("Must be inside WizardProvider");
  return ctx;
}
